module.exports = __webpack_public_path__ + "static/media/location.faf5d883.svg";